import {
  buildNotification,
  delocalizeContent,
  localizeTemplateVariables
} from 'components/event_type_edit'

export const getDefaultTiming = (defaultNotification) => (defaultNotification.timings || [{}])[0]

export const getInitialValues = (eventType, kind) => ({
  [kind]: buildNotification(eventType, kind),
  noReply: eventType.no_reply_enabled ? 'no-reply' : 'hosts',
  cancellationAllowed: eventType.cancellation_allowed,
  cancellationPolicy: eventType.cancellation_policy || '',
  assignedSenderId: eventType.expected_calendar_pusher_membership_id,
  notificationType: eventType.notification_type,
})

export const notificationToggleToServerData = (notification) => {
  const data = {}

  const toggleData = {
    enabled: notification.enabled,
    timings: notification.timings
  }

  if (['invitee_sms_reminder', 'invitee_email_follow_up'].includes(notification.kind)) {
    data[`${notification.kind}_attributes`] = toggleData
  } else {
    data.message_customizations = { [notification.kind]: toggleData }
  }

  return data
}

const notificationToServerData = (notification) => {
  const data = {}

  const notificationData = {
    enabled: notification.enabled,
    subject: delocalizeContent(
      notification.subject.html, localizeTemplateVariables(notification.variables.subject)),
    body: delocalizeContent(
      notification.body.html, localizeTemplateVariables(notification.variables.body)),
    timings: notification.timings
  }

  if (['invitee_sms_reminder', 'invitee_email_follow_up'].includes(notification.kind)) {
    data[`${notification.kind}_attributes`] = notificationData
  } else {
    data.message_customizations = { [notification.kind]: notificationData }
  }

  return data
}

export const formValuesToServerData = (values, kind) => ({
  no_reply_enabled: values.noReply === 'no-reply',
  cancellation_allowed: values.cancellationAllowed,
  cancellation_policy: values.cancellationPolicy,
  notification_type: values.notificationType,
  assigned_sender_id: values.assignedSenderId,
  ...notificationToServerData(values[kind])
})
